import { render, staticRenderFns } from "./alertLayout.vue?vue&type=template&id=0e5f4bec&scoped=true&"
import script from "./alertLayout.vue?vue&type=script&lang=js&"
export * from "./alertLayout.vue?vue&type=script&lang=js&"
import style0 from "./alertLayout.vue?vue&type=style&index=0&id=0e5f4bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5f4bec",
  null
  
)

export default component.exports